import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getEmpresas = async () => {
    let empresas = null;
    try {
        const response = await api.get(`Empresa/listcontroller`, config);
        empresas = response.data.data;
    } catch (err) {}
    return empresas;
}